import { ApiService } from '../utility-services/Api.service';
import type { AdminBanner } from '../interfaces/AdminBanner';

// Consumes the /banners CRUD endpoints implemented in diwo-helper-api (DIWO-5777)
export class BannerService {
	apiService = new ApiService();

	getBanners(notifyOnError = true): Promise<AdminBanner[]> {
		return this.apiService.get<AdminBanner[]>(
			'banners',
			undefined,
			undefined,
			false,
			notifyOnError
		);
	}

	createBanner(banner: Omit<AdminBanner, 'id'>): Promise<AdminBanner> {
		return this.apiService.post<AdminBanner, Omit<AdminBanner, 'id'>>('banners', banner);
	}

	updateBanner(id: string, banner: Omit<AdminBanner, 'id'>): Promise<AdminBanner> {
		return this.apiService.putWithBody<AdminBanner, Omit<AdminBanner, 'id'>>(
			`banners/${id}`,
			banner
		);
	}

	deleteBanner(id: string): Promise<void> {
		return this.apiService.delete<void>(`banners/${id}`);
	}
}
